import React from 'react'
import { useStateValue } from '@State'
import PropTypes from 'prop-types'
import { Indicator } from '@CommonComponents'

export const Section = props => {
  const [currentState, dispatch] = useStateValue()

  const handleChange = sectId => {
    let selectedIds = currentState.selectedSections
    if (props.selected) {
      // unchecking chapter checkbox
      selectedIds = selectedIds.filter(item => item !== sectId)
    } else {
      if (!selectedIds.includes(sectId)) {
        selectedIds.push(sectId)
      }
    }

    dispatch({
      type: 'sectionSelection',
      selectedSections: selectedIds,
    })
  }

  return (
    <div key={props.secId} className="d-flex align-items-center">
      <Indicator display={props.inCanvas} className="mt-1" />
      <input
        className="ml-1"
        type="checkbox"
        disabled={currentState.linksPosting || currentState.linksPosted}
        checked={props.selected}
        onChange={() => handleChange(props.secId)}
      />{' '}
      <span className="ml-2">{props.title}</span>
    </div>
  )
}

Section.propTypes = {
  selected: PropTypes.bool,
  title: PropTypes.string,
  secId: PropTypes.string,
  inCanvas: PropTypes.bool,
  chapId: PropTypes.string,
}
